/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewings_AddInputs */

const cs_viewings_add = /** @type {(inputs: Viewings_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naplánovat prohlídku`)
};

const en_viewings_add = /** @type {(inputs: Viewings_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schedule viewing`)
};

/**
* | output |
* | --- |
* | "Schedule viewing" |
*
* @param {Viewings_AddInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const viewings_add = /** @type {((inputs?: Viewings_AddInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewings_AddInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewings_add(inputs)
	return cs_viewings_add(inputs)
});